import { IDashboardModuleConfig } from '@mt-ng2/dashboard';
import { ClaimTypes } from '@model/ClaimTypes';

export const recommendedPagesModuleConfig: IDashboardModuleConfig = {
    userRolesClaimTypeId: ClaimTypes.UserRoles,
};
